module.exports = __webpack_public_path__ + "static/media/IMG_1785.77611b26.jpg";